






























































import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator'
import PicModal from '@/components/upload/picModal.vue'
import SelectUrl from '@/components/selectUrl/index.vue'
@Component({
  components: {
    PicModal,
    SelectUrl,
  },
})
export default class Grid extends Vue {
  @Prop({
    type: Boolean,
    default: () => false,
  })
  showDemo!: boolean

  @Prop({
    type: Object,
    default: () => {
      return {
        type: 'grid',
        columnNum: 4,
        linkType: 'navigateTo',
        items: [
          {
            icon: null,
            text: null,
            url: null,
          },
        ],
      }
    },
  })
  GridConfig!: any
  linkList = ['navigateTo', 'redirectTo', 'switchTab', 'reLaunch']

  mounted() {}

  /**
   * 选择图片
   */
  picChange(e, index) {
    this.GridConfig.items[index]['icon'] = e[0].url
  }

  urlChange(e, index) {
    this.GridConfig.items[index]['url'] = e
  }

  /**
   * 删除图片
   */
  deleteFn(index) {
    this.GridConfig.items.splice(index, 1)
  }

  /**
   * 添加图片
   */
  addFn() {
    let obj = {
      icon: null,
      text: null,
      url: null,
    }
    this.GridConfig.items.push(obj)
  }
}
